import AddEnquiry from "./Components/Enquiry/AddEnquiry";
import UploadEnquiry from "./Components/Enquiry/UploadEnquiry";
import ViewEnquiry from "./Components/ViewEnquiry";
import AddQuotation from "./Components/AddQuotation";
import NotificationBox from "./Components/NotificationBox";
import BestMatchingQuotation from "./Components/BestMatchingQuotation";
import GeneareteReceiptVoucher from "./Components/GeneareteReceiptVoucher";
import QcWorkscreen from "./Components/QcWorkscreen";
import QcEnquiry from "./Components/QcEnquiry";
import AuxBox from "./Components/AuxBox";
import BookingList from "./Components/BookingList";
import NewTicket from "./Components/Ticket/NewTicket";
import TicketList from "./Components/Ticket/List";
import ReplyTicket from "./Components/Ticket/ReplyTicket";
import ViewTicket from "./Components/Ticket/ViewTicket";
import EnquiryList from "./Components/Enquiry/List";
import EnquiryListCard from "./Components/Enquiry/ListCard";
import EnquiryAction from "./Components/Enquiry/EnquiryAction";
import OnlineBookingList from "./Components/OnlineBookingList";
import ViewOnlineBooking from "./Components/ViewOnlineBooking";
import UsersList from "./Components/Users/List";
import UsersListCard from "./Components/Users/ListCard";
import AgentBookingReportList from "./Components/Report/AgentBookingReportList";
import LeadsReportList from "./Components/Report/LeadsReportList";
import BookingsReportList from "./Components/Report/BookingsReportList";
import BookingsProfitReportList from "./Components/Report/BookingsProfitReportList";
import PaymentHistoryList from "./Components/Report/PaymentHistoryList";
import SalesDashboard from "./Components/Dashboard/SalesDashboard";
import QCDashboard from "./Components/Dashboard/QCDashboard";
import OtpVerify from "./Components/Auth/OtpVerify";
import Login from "./Components/Auth/Login";
import AddNewQuotation from "./Components/Quotation/Add";
import NewBestMatchingQuotation from "./Components/Quotation/NewBestMatchingQuotation";
import GeneareteHotelVoucher from "./Components/Vouchers/GeneareteHotelVoucher";
import GeneareteFlightVoucher from "./Components/Vouchers/GeneareteFlightVoucher";
import GeneareteLandVoucher from "./Components/Vouchers/GeneareteLandVoucher";
import QuotationPricingSettings from "./Components/Settings/QuotationPricingSettings";
import FollowupReminderSettings from "./Components/Settings/FollowupReminderSettings";
import FollowupCampaigns from "./Components/Marketing/FollowupCampaigns";
import StatusFollowups from "./Components/Marketing/StatusFollowups";
import TripFulfilmentPage from "./Components/Operations/TripFulfilmentPage";
import OperationsBoard from "./Components/Operations/OperationsBoard";
import ChecklistTemplatesAdmin from "./Components/Operations/ChecklistTemplatesAdmin";




import QCEnquiryList from "./Components/Enquiry/QCList";

import Vue3NativeNotification from 'vue3-native-notification'


require('./bootstrap');

import { createApp } from 'vue'
import Select2 from 'vue3-select2-component';
import SearchBox from "./Components/SearchBox";
import timeago from 'vue-timeago3';
import ElementPlus from 'element-plus'


const app = createApp({});

app.use(Vue3NativeNotification, {
    requestOnNotify: true
});
app.use(timeago);
app.use(ElementPlus);
app.component('qc-enquiry-list', QCEnquiryList);

app.component('new-ticket', NewTicket);
app.component('view-ticket', ViewTicket);
app.component('add-enquiry', AddEnquiry);
app.component('upload-enquiry', UploadEnquiry);
app.component('view-enquiry', ViewEnquiry);
app.component('add-quotation', AddQuotation);
app.component('best-matching-quotation', BestMatchingQuotation);
app.component('genearete-receipt-voucher', GeneareteReceiptVoucher);
app.component('search-box', SearchBox);
app.component('notification-box', NotificationBox);
app.component('Select2', Select2);
app.component('qc-workscreen', QcWorkscreen);
app.component('qc-enquiry', QcEnquiry);
app.component('aux-box', AuxBox);
app.component('booking-list', BookingList);
app.component('tickets-list', TicketList);
app.component('replay-tickets', ReplyTicket);
app.component('enquiry-list', EnquiryList);
app.component('enquiry-list-card', EnquiryListCard);
app.component('enquiry-action', EnquiryAction);
app.component('online-booking-list', OnlineBookingList);
app.component('view-onlinebooking', ViewOnlineBooking);
app.component('users-list', UsersList);
app.component('users-list-card', UsersListCard);
app.component('agent-booking-report-list', AgentBookingReportList);
app.component('leads-report-list', LeadsReportList);
app.component('bookings-report-list', BookingsReportList);
app.component('bookings-profit-report-list', BookingsProfitReportList);
app.component('payment-history-list', PaymentHistoryList);
app.component('sales-dashboard', SalesDashboard);
app.component('qc-dashboard', QCDashboard);
app.component('otp-verify', OtpVerify);
app.component('login', Login);
app.component('add-new-quotation', AddNewQuotation);
app.component('new-best-matching-quotation', NewBestMatchingQuotation);

app.component('genearete-hotel-voucher', GeneareteHotelVoucher);
app.component('genearete-flight-voucher', GeneareteFlightVoucher);
app.component('generate-land-voucher', GeneareteLandVoucher);
app.component('quotation-pricing-settings', QuotationPricingSettings);
app.component('followup-reminder-settings', FollowupReminderSettings);
app.component('followup-campaigns', FollowupCampaigns);
app.component('status-followups', StatusFollowups);
app.component('trip-fulfilment-page', TripFulfilmentPage);
app.component('operations-board', OperationsBoard);
app.component('checklist-templates-admin', ChecklistTemplatesAdmin);



app.mount('#app')



